export enum BulletType {
    CUSTOMER = 'CUSTOMER',
    COLLECTION = 'COLLECTION',
    ADD_COLLECTION_BUTTON = 'ADD_COLLECTION_BUTTON',
    DELIVERY = 'DELIVERY',
    ADD_DELIVERY_BUTTON = 'ADD_DELIVERY_BUTTON',
    GOODS = 'GOODS',
    SHIPPER_CONSIGNEE_NOTIFY = 'SHIPPER_CONSIGNEE_NOTIFY',
    OTHER_INFO = 'OTHER_INFO',
} 